module.exports = __webpack_public_path__ + "static/media/purim.802c5f57.svg";